/* eslint-disable default-case */

import { trackEvent } from "./helpers";

let instances = [];
const EVENTS = {
    VIDEO_PLAYED: "video_played",
    VIDEO_PAUSED: "video_paused",
    VIDEO_FINISHED: "video_finished",
};

class TrackVideo {
    /**
     * Track video events.
     *
     * @param  {HTMLElement} videoWrapper
     * @return {void}
     */
    constructor(videoWrapper) {
        this.videoWrapper = videoWrapper;
        this.wrapperId = this.videoWrapper.getAttribute("id");
        this.player = window[this.wrapperId];
        this.videoType = this.videoWrapper.getAttribute("data-video-type");
        this.videoId = this.videoWrapper.getAttribute("data-video-id");

        // wait until the video is loaded before assigning tracking events
        document.addEventListener("video_loaded_" + this.wrapperId, () => {
            this.player = window[this.wrapperId];
            this.trackVideoEvents();
        });
    }

    /**
     * Bind tracking events.
     *
     * @return {void}
     */
    trackVideoEvents() {
        switch (this.videoType) {
            case "vimeo": {
                this.player.getVideoTitle().then((video_title) => {
                    this.player.on("play", (event) => {
                        trackEvent(EVENTS.VIDEO_PLAYED, {
                            video_title,
                            video_duration: event.duration,
                        });
                    });

                    this.player.on("pause", (event) => {
                        trackEvent(EVENTS.VIDEO_PAUSED, {
                            video_title,
                            paused_at: event.seconds,
                        });
                    });

                    this.player.on("ended", (event) => {
                        trackEvent(EVENTS.VIDEO_FINISHED, {
                            video_title,
                            video_duration: event.duration,
                        });
                    });
                });
                break;
            }
            case "youtube": {
                this.player.addEventListener("onStateChange", (event) => {
                    const video_title = event.target.videoTitle;
                    switch (event.data) {
                        case 1: {
                            const duration = event.target.getDuration();
                            trackEvent(EVENTS.VIDEO_PLAYED, {
                                video_title,
                                // YouTube is much more exact, round to 2 decimal places to match Vimeo
                                video_duration: Math.round(duration * 100) / 100,
                            });
                            break;
                        }
                        case 2: {
                            const currentTime = event.target.getCurrentTime();
                            trackEvent(EVENTS.VIDEO_PAUSED, {
                                video_title,
                                // YouTube is much more exact, round to 3 decimal places to match Vimeo
                                paused_at: Math.round(currentTime * 1000) / 1000,
                            });
                            break;
                        }
                        case 0: {
                            const duration = event.target.getDuration();
                            trackEvent(EVENTS.VIDEO_FINISHED, {
                                video_title,
                                // YouTube is much more exact, round to 2 decimal places to match Vimeo
                                video_duration: Math.round(duration * 100) / 100,
                            });
                            break;
                        }
                    }
                });
                break;
            }
            case "self-hosted": {
                this.player.onplay = (event) => {
                    const duration = event.target.duration;
                    trackEvent(EVENTS.VIDEO_PLAYED, {
                        video_title: this.videoId,
                        // HTML Video is much more exact, round to 2 decimal places to match Vimeo
                        video_duration: Math.round(duration * 100) / 100,
                    });
                };

                this.player.onpause = (event) => {
                    const currentTime = event.target.currentTime;
                    const duration = event.target.duration;

                    if (currentTime === duration) return;

                    trackEvent(EVENTS.VIDEO_PAUSED, {
                        video_title: this.videoId,
                        // HTML Video is much more exact, round to 3 decimal places to match Vimeo
                        paused_at: Math.round(currentTime * 1000) / 1000,
                    });
                };

                this.player.onended = (event) => {
                    const duration = event.target.duration;
                    trackEvent(EVENTS.VIDEO_FINISHED, {
                        video_title: this.videoId,
                        // HTML Video is much more exact, round to 2 decimal places to match Vimeo
                        video_duration: Math.round(duration * 100) / 100,
                    });
                };
            }
        }
    }
}

export default {
    init: (videoWrapper) => {
        instances.push(new TrackVideo(videoWrapper));
    },
    destroy: () => {
        instances = [];
    },
};
